import Link from "next/link"

/**
 * Header wordmark only — same home link + a11y copy as site chrome; typography lives in
 * `type-chrome-brand-*` (globals + design tokens).
 */
export function MaatiiChromeBrandLockup({ href }: { href: string }) {
  return (
    <Link
      href={href}
      aria-label="MAATII Events home"
      className="type-chrome-brand-lockup focus-ring -my-1 inline-flex shrink-0 flex-col items-start rounded-sm py-1 leading-none outline-none"
    >
      <span className="type-chrome-brand-wordmark" aria-hidden={true}>
        MAATII
      </span>
      <span className="type-chrome-brand-tagline" aria-hidden={true}>
        events
      </span>
    </Link>
  )
}
